import { Component, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { IconComponent } from "@claas/claas-ui-components";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "claas-internal-server-error",
  imports: [TranslatePipe, IconComponent, RouterLink],
  templateUrl: "./internal-server-error.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./internal-server-error.scss",
})
export class InternalServerError {}
